/**
 * C12 providers view-model — pure display shaping for the read-only service-provider
 * network screen: the avatar/emoji per provider type, the read-only network status,
 * the type-chip builder, and the client-side type + free-text filter. Kept out of the
 * .vue so node:test can cover the logic directly (the companies repo has no SFC test
 * runner). The template just binds the output.
 */

// Provider type -> { icon (emoji), cls (avatar accent class from vivo-components.css) }.
var TYPE_META = {
  hospital: { icon: '🏥', cls: '' },
  lab: { icon: '🔬', cls: 'a2' },
  pharmacy: { icon: '💊', cls: 'a3' },
  radiology: { icon: '🩻', cls: 'a3' },
  dental: { icon: '🦷', cls: '' },
  clinic: { icon: '🩺', cls: 'a3' },
};

// Stable chip order (mirrors the mockup's chip row); only types present in the data render.
var TYPE_ORDER = ['hospital', 'lab', 'pharmacy', 'radiology', 'dental', 'clinic'];

function avatarFor(type) {
  return TYPE_META[type] || { icon: '🏥', cls: '' };
}

// Read-only network status: contracted vs suspended, keyed for i18n (the .tag class is
// picked in the view). The insurer owns this flag; the HR portal only reflects it.
function statusOf(provider) {
  return provider && provider.isActive === false ? 'suspended' : 'active';
}

function norm(v) {
  return String(v == null ? '' : v).trim().toLowerCase();
}

// Filter the (already-localized) rows by the selected type chip + the free-text query.
// Rows may carry a localized `typeLabel`, which is included in the text haystack so an
// Arabic search like "مستشفى" matches even though the raw `type` field is English.
function filterProviders(rows, opts) {
  var list = rows || [];
  var o = opts || {};
  var type = o.type;
  var q = norm(o.q);
  return list.filter(function (row) {
    if (type && type !== 'all' && row.type !== type) return false;
    if (!q) return true;
    var hay = [row.name, row.city, row.networkName, row.typeLabel, row.type].map(norm);
    return hay.some(function (h) {
      return h.indexOf(q) !== -1;
    });
  });
}

// Build the type chips (type + count) for the types actually present, in TYPE_ORDER;
// any unknown type is appended stably at the end so nothing is silently dropped.
function typeChips(rows) {
  var list = rows || [];
  var counts = {};
  for (var i = 0; i < list.length; i++) {
    var t = list[i].type;
    counts[t] = (counts[t] || 0) + 1;
  }
  var chips = [];
  for (var j = 0; j < TYPE_ORDER.length; j++) {
    var key = TYPE_ORDER[j];
    if (counts[key]) chips.push({ type: key, count: counts[key] });
  }
  Object.keys(counts).forEach(function (k) {
    if (TYPE_ORDER.indexOf(k) === -1) chips.push({ type: k, count: counts[k] });
  });
  return chips;
}

module.exports = {
  TYPE_META: TYPE_META,
  TYPE_ORDER: TYPE_ORDER,
  avatarFor: avatarFor,
  statusOf: statusOf,
  filterProviders: filterProviders,
  typeChips: typeChips,
};
